import { Component } from "./Component"

export class LocalComponent extends Component {
  static isLocalComponent = true
}
